import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section className="banner_passion" style={{ background: "#FAFBFF" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h1>
              Passion Painting Doesn’t Just Paint Houses, It’s a One Stop
              Solution
            </h1>
            <p>
              Consider Passion Painting as The Premier Experts In All Kinds Of
              Interior & Exterior Painting Jobs. Aiming To Make Your House Look
              As Good As New.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-auto text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/passion-painting/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1120}
                height={1112}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
